import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { toast } from "react-toastify";
import ContentLayout from "../../layout/ContentLayout";
import { Container } from "../../components/content";
import styles from "../../styles/mobileInfoPage.module.scss";
import quizService from "../../api/quiz-api";
import QuizFormFields from "../../components/quiz/QuizFormFields";
import { emptyQuizForm, validatedQuizForm } from "../../utils/quiz.util";

export default function DodajKviz() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState(emptyQuizForm());
    const [saving, setSaving] = useState(false);

    const updateFormData = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSave = async () => {
        if (!validatedQuizForm(formData)) return;

        setSaving(true);
        try {
            const response = await quizService.create(formData);
            if (!response.success) {
                toast.error(response.message || 'Greška prilikom čuvanja kviza');
                return;
            }
            toast.success('Kviz je uspešno kreiran!');
            navigate('/kvizovi');
        } finally {
            setSaving(false);
        }
    };

    return (
        <Container>
            <Link to="/kvizovi" className="link_btn" style={{ marginBottom: '12px' }}>
                <img alt="back" src="/assets/icons/chevron.svg" />
                <span>Nazad</span>
            </Link>

            <ContentLayout pt={true}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
                    <h2 className={styles.pageTitle} style={{ margin: 0 }}>Novi kviz</h2>
                    <Button className="btn-primary" onClick={handleSave} loading={saving}>
                        Kreiraj kviz
                    </Button>
                </div>

                <QuizFormFields formData={formData} updateFormData={updateFormData} />
            </ContentLayout>
        </Container>
    );
}
